
import { PaletteColorOptions } from '@mui/material/styles';
import { ThemeMode } from 'config';
import { PalettesProps } from '@ant-design/colors';
import { PaletteThemeProps } from 'types/theme';

export function Theme9(colors: PalettesProps, mode: ThemeMode): PaletteThemeProps {
  const { grey } = colors;
  const greyColors: PaletteColorOptions = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };

  const contrastText = '#fff';

  let primaryColors = ['#E8F0FF', '#C5DAFF', '#8FB8FF', '#5F97F2', '#346ECC', '#173B72', '#112A52', '#0B1C36', '#061222', '#02070F'];

  if (mode === ThemeMode.DARK) {
    primaryColors = ['#0B1C36', '#0F2A52', '#173B72', '#1E4E95', '#2E66C2', '#3F7FEE', '#6EA0F7', '#9AC1FA', '#C7DEFF', '#E8F0FF'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    grey: greyColors
  } as any;
}


